import * as React from 'react'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

import './style.scss'

interface IProps {
  values: any[]
  label: string
  input: any
  onChangeSelect: any
  initialValue?: string
}

interface IState {
  value: string
}

export class SelectComponent extends React.Component<IProps, IState> {
  state = {
    value: ''
  }

  handleChange = event => {
    this.setState({ value: event.target!.value })
    this.props.onChangeSelect(event.target!.value)
  }

  componentDidMount() {
    const { initialValue } = this.props
    this.setState({ value: initialValue ? initialValue : '' })
  }

  render() {
    let { values } = this.props
    const { input, label } = this.props
    values = values.map((item, i) => (
      <MenuItem key={i} value={item.value}>
        {item.name}
      </MenuItem>
    ))

    return (
      <FormControl className="select-form-control">
        <InputLabel htmlFor={`${input.name}-field`}>{label}</InputLabel>
        <Select
          value={this.state.value}
          onChange={this.handleChange}
          inputProps={{
            name: input.name,
            id: `${input.name}-field`
          }}
        >
          {values}
        </Select>
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/index.tsx